
import { Typography, Button } from "../../components"
import "./styles.css";

import ervaringenPDF from '../../assets/documents/library/ervaringen-ouders-en-zorgprofessionals/document.pdf';

export default function Ervaringen(props) {
    return (
        <div className='container'>
            <Typography type='h1' style={{ color: 'var(--trust)', fontSize: '2.2em' }}>Ervaringen met NOLIA BabyFeeding</Typography>
            <div className="button-container">
                <Button 
                    target='_blank' 
                    href={ervaringenPDF} 
                    text={`Lees hier de ervaringen van ouders en zorgprofessionals met NOLIA BabyFeeding`}
                />  
            </div>
        </div>
    )
}
